import { render } from "./AppBaseMultipleSelect.vue?vue&type=template&id=2c84b4e0"
import script from "./AppBaseMultipleSelect.vue?vue&type=script&lang=js"
export * from "./AppBaseMultipleSelect.vue?vue&type=script&lang=js"

import "./AppBaseMultipleSelect.vue?vue&type=style&index=0&id=2c84b4e0&lang=scss"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__